import * as u from "react-i18next";

export function translateLanguage(name: string, nameKH: string) {
    return u.getI18n().language === "kh" ? nameKH : name;
}